import styled from '@emotion/styled'
import { wrap as withStyle } from 'utils/styles'
import BoundariesTable from './BoundariesTable'

export default withStyle((props) => {
  return `
    padding-top: 5px;
    margin-top: 10px;
    border-top: 1px solid ${props.theme.basicBoxBorderColor};

    >div + div {
      margin-top: 10px;
    }
  `
})

export const StyledContainer = styled.div(
  (props) => `
  margin-top: 10px;
  border-top: 1px solid ${props.theme.basicBoxBorderColor};

  ${BoundariesTable} {
    margin-top: 10px;
  }
`
)
